// THIS CODE WAS AUTO-GENERATED from '/packages/icon/icons/makeSvgsIntoJsx.js'
// PLEASE DO NOT EDIT HERE. EDIT THE FILE THAT MADE THIS
import React from 'react'
import { sanitizeProps } from '@fs/zion-frontend-friends'
import { BaseIcon, type IconProps } from '../BaseIcon'
import { rtlFlipCss } from '../iconStyles'

export default (props: IconProps): JSX.Element => (
  <BaseIcon {...sanitizeProps(props)}>
    <path
      fillRule="evenodd"
      d="M7.74 10.74h2.33L7.18 2.26H4.5l-2.9 8.48h2.24l.55-1.86H7.2l.54 1.86Zm-1.9-6.36L6.9 7.56H4.78l1.06-3.18ZM21 15H3v-2h18v2Zm0 5H3v-2h18v2ZM11.77 8H21v2h-8.55l-.68-2Z"
      className={rtlFlipCss}
    />
  </BaseIcon>
)
